export default "__VITE_ASSET__CvrqePM9__"